import { assert } from '@ember/debug';
import { isEmpty } from '@ember/utils';

const nonexistentOptions = [undefined, null];

function optionalAssertion({ message, type, argument }) {
  assert(message, typeof argument === type || nonexistentOptions.includes(argument));
}

function requiredAssertion({ message, type, argument }) {
  assert(message, typeof argument === type && !isEmpty(argument));
}

function optionalAction({ action, component, message, name }) {
  optionalAssertion({
    message: message || `@${name} argument for ${component} must be an action or empty`,
    type: 'function',
    argument: action,
  });
}

function optionalBoolean({ argument, component, message, name }) {
  optionalAssertion({
    message: message || `@${name} argument of ${component} must be a Boolean value or empty`,
    type: 'boolean',
    argument,
  });
}

function optionalConfigOption({ options, selected, name, component }) {
  assert(
    `@${name} argument of ${component} must be one of ${options.join(', ')} or empty`,
    options.includes(selected) || nonexistentOptions.includes(selected)
  );
}

function optionalString({ argument, component, message, name }) {
  optionalAssertion({
    message: message || `@${name} argument of ${component} must be a string or empty`,
    type: 'string',
    argument,
  });
}

function requiredAction({ action, component, message, name }) {
  requiredAssertion({
    message: message || `@${name} argument of ${component} must be an action`,
    type: 'function',
    argument: action,
  });
}

function requiredConfigOption({ options, selected, name, component }) {
  assert(
    `@${name} argument of ${component} must be one of ${options.join(', ')}`,
    options.includes(selected) && !isEmpty(selected)
  );
}

function requiredString({ argument, component, message, name }) {
  requiredAssertion({
    message: message || `@${name} argument of ${component} must be a string`,
    type: 'string',
    argument,
  });
}

export {
  optionalAction,
  optionalBoolean,
  optionalConfigOption,
  optionalString,
  requiredAction,
  requiredConfigOption,
  requiredString,
};
